var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.33337H12.5C13.6027 3.33337 14.5 4.27537 14.5 5.43271V10.2334C14.5 11.3914 13.6027 12.3334 12.5 12.3334H3.5C2.39733 12.3334 1.5 11.3914 1.5 10.2334V5.43271C1.5 4.27537 2.39733 3.33337 3.5 3.33337ZM3.61 4.33337H12.3773L7.972 8.02271L3.61 4.33337ZM3.5 11.3334C3.43933 11.3334 3.38 11.3247 3.322 11.314L6.91867 8.44137L7.648 9.05804C7.74067 9.13671 7.856 9.17671 7.97067 9.17671C8.08467 9.17671 8.19867 9.13737 8.29133 9.06004L9.05533 8.42071L12.6773 11.314C12.62 11.3247 12.5607 11.3334 12.5 11.3334H3.5ZM2.5 10.2334C2.5 10.3754 2.52667 10.51 2.57067 10.634L6.14067 7.78337L2.66067 4.84004C2.56 5.01137 2.5 5.21404 2.5 5.43271V10.2334ZM9.83733 7.76537L13.3373 4.83471C13.4393 5.00737 13.5 5.21204 13.5 5.43271V10.2334C13.5 10.3754 13.4733 10.51 13.4287 10.6347L9.83733 7.76537Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.fcb5bdf6ab07f9540002d1a5fcb618bd.svg";
export { ForwardRef as ReactComponent };